var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgressTransitionManager = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _threads = require("../../threads");
var _core = require("../../core");
var _reactNative = require("react-native");
var _worklet_733189383917_init_data = {
    code: "function anonymous(){const{viewTag,progressAnimation}=this.__closure;global.ProgressTransitionRegister.addProgressAnimation(viewTag,progressAnimation);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts",
    sourceMap: '{"version":3,"names":["anonymous","viewTag","progressAnimation","__closure","global","ProgressTransitionRegister","addProgressAnimation"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts"],"mappings":"AA2BuB,SAAAA,SAAMA,CAAA,QAAAC,OAAA,CAAAC,iBAAA,OAAAC,SAAA,CAEvBC,MAAM,CAACC,0BAA0B,CAACC,oBAAoB,CACpDL,OAAO,CACPC,iBACF,CAAC,CACH"}',
    version: "3.5.4"
};
var _worklet_15289183256234_init_data = {
    code: "function anonymous(){const{viewTag}=this.__closure;global.ProgressTransitionRegister.removeProgressAnimation(viewTag);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts",
    sourceMap: '{"version":3,"names":["anonymous","viewTag","__closure","global","ProgressTransitionRegister","removeProgressAnimation"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts"],"mappings":"AAuCuB,SAAAA,SAAMA,CAAA,QAAAC,OAAA,OAAAC,SAAA,CAEvBC,MAAM,CAACC,0BAA0B,CAACC,uBAAuB,CAACJ,OAAO,CAAC,CACpE"}',
    version: "3.5.4"
};
var _worklet_7494210000180_init_data = {
    code: "function anonymous(event){const{lastProgressValue}=this.__closure;const progress=event.progress;if(progress===lastProgressValue){return;}lastProgressValue=progress;global.ProgressTransitionRegister.frame(progress);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts",
    sourceMap: '{"version":3,"names":["anonymous","event","lastProgressValue","__closure","progress","global","ProgressTransitionRegister","frame"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts"],"mappings":"AAqDQ,QAAC,CAAAA,SAAmCA,CAAAC,KAAA,QAAAC,iBAAA,OAAAC,SAAA,CAElC,KAAM,CAAAC,QAAQ,CAAGH,KAAK,CAACG,QAAQ,CAC/B,GAAIA,QAAQ,GAAKF,iBAAiB,CAAE,CAIlC,OACF,CACAA,iBAAiB,CAAGE,QAAQ,CAC5BC,MAAM,CAACC,0BAA0B,CAACC,KAAK,CAACH,QAAQ,CAAC,CACnD"}',
    version: "3.5.4"
};
var _worklet_3584216964250_init_data = {
    code: "function anonymous(){global.ProgressTransitionRegister.onTransitionEnd();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts",
    sourceMap: '{"version":3,"names":["anonymous","global","ProgressTransitionRegister","onTransitionEnd"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts"],"mappings":"AAmEmD,SAAAA,SAAMA,CAAA,EAEjDC,MAAM,CAACC,0BAA0B,CAACC,eAAe,CAAC,CAAC,CACrD"}',
    version: "3.5.4"
};
var _worklet_3552696675293_init_data = {
    code: "function anonymous(){global.ProgressTransitionRegister.onAndroidFinishTransitioning();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts",
    sourceMap: '{"version":3,"names":["anonymous","global","ProgressTransitionRegister","onAndroidFinishTransitioning"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts"],"mappings":"AA2EwD,SAAAA,SAAMA,CAAA,EAEpDC,MAAM,CAACC,0BAA0B,CAACC,4BAA4B,CAAC,CAAC,CAClE"}',
    version: "3.5.4"
};
var _worklet_16472804869484_init_data = {
    code: "function anonymous(){global.ProgressTransitionRegister.onTransitionEnd(true);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts",
    sourceMap: '{"version":3,"names":["anonymous","global","ProgressTransitionRegister","onTransitionEnd"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts"],"mappings":"AAiFwD,SAAAA,SAAMA,CAAA,EAEpDC,MAAM,CAACC,0BAA0B,CAACC,eAAe,CAAC,IAAI,CAAC,CACzD"}',
    version: "3.5.4"
};
var _worklet_3584216964250_init_data2 = {
    code: "function anonymous(){global.ProgressTransitionRegister.onTransitionEnd();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts",
    sourceMap: '{"version":3,"names":["anonymous","global","ProgressTransitionRegister","onTransitionEnd"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts"],"mappings":"AAqF2D,SAAAA,SAAMA,CAAA,EAEvDC,MAAM,CAACC,0BAA0B,CAACC,eAAe,CAAC,CAAC,CACrD"}',
    version: "3.5.4"
};
var ProgressTransitionManager = exports.ProgressTransitionManager = function() {
    function ProgressTransitionManager() {
        (0, _classCallCheck2.default)(this, ProgressTransitionManager);
        this._sharedElementCount = 0;
        this._eventHandler = {
            isRegistered: false,
            onTransitionProgress: -1,
            onAppear: -1,
            onDisappear: -1,
            onSwipeDismiss: -1
        };
    }
    (0, _createClass2.default)(ProgressTransitionManager, [
        {
            key: "addProgressAnimation",
            value: function addProgressAnimation(viewTag, progressAnimation) {
                (0, _threads.runOnUIImmediately)(function() {
                    var _e = [
                        new global.Error(),
                        -3,
                        -27
                    ];
                    var anonymous = function anonymous() {
                        global.ProgressTransitionRegister.addProgressAnimation(viewTag, progressAnimation);
                    };
                    anonymous.__closure = {
                        viewTag: viewTag,
                        progressAnimation: progressAnimation
                    };
                    anonymous.__initData = _worklet_733189383917_init_data;
                    anonymous.__workletHash = 733189383917;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }())();
                this.registerEventHandlers();
            }
        },
        {
            key: "removeProgressAnimation",
            value: function removeProgressAnimation(viewTag) {
                this.unregisterEventHandlers();
                (0, _threads.runOnUIImmediately)(function() {
                    var _e = [
                        new global.Error(),
                        -2,
                        -27
                    ];
                    var anonymous = function anonymous() {
                        global.ProgressTransitionRegister.removeProgressAnimation(viewTag);
                    };
                    anonymous.__closure = {
                        viewTag: viewTag
                    };
                    anonymous.__initData = _worklet_15289183256234_init_data;
                    anonymous.__workletHash = 15289183256234;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }())();
            }
        },
        {
            key: "registerEventHandlers",
            value: function registerEventHandlers() {
                this._sharedElementCount++;
                var eventHandler = this._eventHandler;
                if (!eventHandler.isRegistered) {
                    eventHandler.isRegistered = true;
                    var eventPrefix = _reactNative.Platform.OS === "android" ? "on" : "top";
                    var lastProgressValue = -1;
                    eventHandler.onTransitionProgress = (0, _core.registerEventHandler)(function() {
                        var _e = [
                            new global.Error(),
                            -2,
                            -27
                        ];
                        var anonymous = function anonymous(event) {
                            var progress = event.progress;
                            if (progress === lastProgressValue) {
                                return;
                            }
                            lastProgressValue = progress;
                            global.ProgressTransitionRegister.frame(progress);
                        };
                        anonymous.__closure = {
                            lastProgressValue: lastProgressValue
                        };
                        anonymous.__initData = _worklet_7494210000180_init_data;
                        anonymous.__workletHash = 7494210000180;
                        anonymous.__stackDetails = _e;
                        return anonymous;
                    }(), eventPrefix + "TransitionProgress");
                    eventHandler.onAppear = (0, _core.registerEventHandler)(function() {
                        var _e = [
                            new global.Error(),
                            1,
                            -27
                        ];
                        var anonymous = function anonymous() {
                            global.ProgressTransitionRegister.onTransitionEnd();
                        };
                        anonymous.__closure = {};
                        anonymous.__initData = _worklet_3584216964250_init_data;
                        anonymous.__workletHash = 3584216964250;
                        anonymous.__stackDetails = _e;
                        return anonymous;
                    }(), eventPrefix + "Appear");
                    if (_reactNative.Platform.OS === "android") {
                        eventHandler.onDisappear = (0, _core.registerEventHandler)(function() {
                            var _e = [
                                new global.Error(),
                                1,
                                -27
                            ];
                            var anonymous = function anonymous() {
                                global.ProgressTransitionRegister.onAndroidFinishTransitioning();
                            };
                            anonymous.__closure = {};
                            anonymous.__initData = _worklet_3552696675293_init_data;
                            anonymous.__workletHash = 3552696675293;
                            anonymous.__stackDetails = _e;
                            return anonymous;
                        }(), "onFinishTransitioning");
                    } else if (_reactNative.Platform.OS === "ios") {
                        eventHandler.onDisappear = (0, _core.registerEventHandler)(function() {
                            var _e = [
                                new global.Error(),
                                1,
                                -27
                            ];
                            var anonymous = function anonymous() {
                                global.ProgressTransitionRegister.onTransitionEnd(true);
                            };
                            anonymous.__closure = {};
                            anonymous.__initData = _worklet_16472804869484_init_data;
                            anonymous.__workletHash = 16472804869484;
                            anonymous.__stackDetails = _e;
                            return anonymous;
                        }(), "topDisappear");
                        eventHandler.onSwipeDismiss = (0, _core.registerEventHandler)(function() {
                            var _e = [
                                new global.Error(),
                                1,
                                -27
                            ];
                            var anonymous = function anonymous() {
                                global.ProgressTransitionRegister.onTransitionEnd();
                            };
                            anonymous.__closure = {};
                            anonymous.__initData = _worklet_3584216964250_init_data2;
                            anonymous.__workletHash = 3584216964250;
                            anonymous.__stackDetails = _e;
                            return anonymous;
                        }(), "topGestureCancel");
                    }
                }
            }
        },
        {
            key: "unregisterEventHandlers",
            value: function unregisterEventHandlers() {
                this._sharedElementCount--;
                if (this._sharedElementCount === 0) {
                    var eventHandler = this._eventHandler;
                    eventHandler.isRegistered = false;
                    if (eventHandler.onTransitionProgress !== -1) {
                        (0, _core.unregisterEventHandler)(eventHandler.onTransitionProgress);
                        eventHandler.onTransitionProgress = -1;
                    }
                    if (eventHandler.onAppear !== -1) {
                        (0, _core.unregisterEventHandler)(eventHandler.onAppear);
                        eventHandler.onAppear = -1;
                    }
                    if (eventHandler.onDisappear !== -1) {
                        (0, _core.unregisterEventHandler)(eventHandler.onDisappear);
                        eventHandler.onDisappear = -1;
                    }
                    if (eventHandler.onSwipeDismiss !== -1) {
                        (0, _core.unregisterEventHandler)(eventHandler.onSwipeDismiss);
                        eventHandler.onSwipeDismiss = -1;
                    }
                }
            }
        }
    ]);
    return ProgressTransitionManager;
}();
var _worklet_15520481641365_init_data = {
    code: "function createProgressTransitionRegister(){const progressAnimations=new Map();const snapshots=new Map();const currentTransitions=new Set();const toRemove=new Set();const progressTransitionManager={addProgressAnimation:function(viewTag,progressAnimation){progressAnimations.set(viewTag,progressAnimation);},removeProgressAnimation:function(viewTag){if(progressAnimations.size>1){toRemove.add(viewTag);}else{progressAnimations.delete(viewTag);}},onTransitionStart:function(viewTag,snapshot){snapshots.set(viewTag,snapshot);currentTransitions.add(viewTag);progressTransitionManager.frame(0);},frame:function(progress){for(const viewTag of currentTransitions){const progressAnimation=progressAnimations.get(viewTag);const snapshot=snapshots.get(viewTag);progressAnimation(viewTag,snapshot,progress);}},onAndroidFinishTransitioning:function(){if(toRemove.size>0){progressTransitionManager.onTransitionEnd();}},onTransitionEnd:function(removeViews=false){for(const viewTag of currentTransitions){_notifyAboutEnd(viewTag,removeViews);}currentTransitions.clear();snapshots.clear();if(toRemove.size>0){for(const viewTag of toRemove){progressAnimations.delete(viewTag);}toRemove.clear();}}};return progressTransitionManager;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts",
    sourceMap: '{"version":3,"names":["createProgressTransitionRegister","progressAnimations","Map","snapshots","currentTransitions","Set","toRemove","progressTransitionManager","addProgressAnimation","viewTag","progressAnimation","set","removeProgressAnimation","size","add","delete","onTransitionStart","snapshot","frame","progress","get","onAndroidFinishTransitioning","onTransitionEnd","removeViews","_notifyAboutEnd","clear"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts"],"mappings":"AAsHA,SAAAA,gCAASA,CAAA,CAAgC,CAEvC,KAAM,CAAAC,kBAAkB,CAAG,GAAI,CAAAC,GAAG,CAA4B,CAAC,CAC/D,KAAM,CAAAC,SAAS,CAAG,GAAI,CAAAD,GAAG,CAAc,CAAC,CACxC,KAAM,CAAAE,kBAAkB,CAAG,GAAI,CAAAC,GAAG,CAAS,CAAC,CAC5C,KAAM,CAAAC,QAAQ,CAAG,GAAI,CAAAD,GAAG,CAAS,CAAC,CAElC,KAAM,CAAAE,yBAAyB,CAAG,CAChCC,oBAAoB,CAAE,QAAAA,CACpBC,OAAe,CACfC,iBAAoC,CACjC,CACHT,kBAAkB,CAACU,GAAG,CAACF,OAAO,CAAEC,iBAAiB,CAAC,CACpD,CAAC,CACDE,uBAAuB,CAAE,QAAAA,CAACH,OAAe,CAAK,CAC5C,GAAIR,kBAAkB,CAACY,IAAI,CAAG,CAAC,CAAE,CAE/BP,QAAQ,CAACQ,GAAG,CAACL,OAAO,CAAC,CACvB,CAAC,IAAM,CACLR,kBAAkB,CAACc,MAAM,CAACN,OAAO,CAAC,CACpC,CACF,CAAC,CACDO,iBAAiB,CAAE,QAAAA,CAACP,OAAe,CAAEQ,QAAa,CAAK,CACrDd,SAAS,CAACQ,GAAG,CAACF,OAAO,CAAEQ,QAAQ,CAAC,CAChCb,kBAAkB,CAACU,GAAG,CAACL,OAAO,CAAC,CAE/BF,yBAAyB,CAACW,KAAK,CAAC,CAAC,CAAC,CACpC,CAAC,CACDA,KAAK,CAAE,QAAAA,CAACC,QAAgB,CAAK,CAC3B,IAAK,KAAM,CAAAV,OAAO,GAAI,CAAAL,kBAAkB,CAAE,CACxC,KAAM,CAAAM,iBAAiB,CAAGT,kBAAkB,CAACmB,GAAG,CAACX,OAAO,CAAC,CACzD,KAAM,CAAAQ,QAAQ,CAAGd,SAAS,CAACiB,GAAG,CAACX,OAAO,CAAC,CACvCC,iBAAiB,CAAED,OAAO,CAAEQ,QAAQ,CAAEE,QAAQ,CAAC,CACjD,CACF,CAAC,CACDE,4BAA4B,CAAE,QAAAA,CAAA,CAAM,CAClC,GAAIf,QAAQ,CAACO,IAAI,CAAG,CAAC,CAAE,CAErBN,yBAAyB,CAACe,eAAe,CAAC,CAAC,CAC7C,CACF,CAAC,CACDA,eAAe,CAAE,QAAAA,CAACC,WAAW,CAAG,KAAK,CAAK,CACxC,IAAK,KAAM,CAAAd,OAAO,GAAI,CAAAL,kBAAkB,CAAE,CACxCoB,eAAe,CAACf,OAAO,CAAEc,WAAW,CAAC,CACvC,CACAnB,kBAAkB,CAACqB,KAAK,CAAC,CAAC,CAC1BtB,SAAS,CAACsB,KAAK,CAAC,CAAC,CACjB,GAAInB,QAAQ,CAACO,IAAI,CAAG,CAAC,CAAE,CACrB,IAAK,KAAM,CAAAJ,OAAO,GAAI,CAAAH,QAAQ,CAAE,CAC9BL,kBAAkB,CAACc,MAAM,CAACN,OAAO,CAAC,CACpC,CACAH,QAAQ,CAACmB,KAAK,CAAC,CAAC,CAClB,CACF,CACF,CAAC,CACD,MAAO,CAAAlB,yBAAyB,CAClC"}',
    version: "3.5.4"
};
var createProgressTransitionRegister = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var createProgressTransitionRegister = function createProgressTransitionRegister() {
        var progressAnimations = new Map();
        var snapshots = new Map();
        var currentTransitions = new Set();
        var toRemove = new Set();
        var progressTransitionManager = {
            addProgressAnimation: function addProgressAnimation(viewTag, progressAnimation) {
                progressAnimations.set(viewTag, progressAnimation);
            },
            removeProgressAnimation: function removeProgressAnimation(viewTag) {
                if (progressAnimations.size > 1) {
                    toRemove.add(viewTag);
                } else {
                    progressAnimations.delete(viewTag);
                }
            },
            onTransitionStart: function onTransitionStart(viewTag, snapshot) {
                snapshots.set(viewTag, snapshot);
                currentTransitions.add(viewTag);
                progressTransitionManager.frame(0);
            },
            frame: function frame(progress) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = currentTransitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var viewTag = _step.value;
                        var progressAnimation = progressAnimations.get(viewTag);
                        var snapshot = snapshots.get(viewTag);
                        progressAnimation(viewTag, snapshot, progress);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            },
            onAndroidFinishTransitioning: function onAndroidFinishTransitioning() {
                if (toRemove.size > 0) {
                    progressTransitionManager.onTransitionEnd();
                }
            },
            onTransitionEnd: function onTransitionEnd() {
                var removeViews = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = currentTransitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var viewTag = _step.value;
                        _notifyAboutEnd(viewTag, removeViews);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                currentTransitions.clear();
                snapshots.clear();
                if (toRemove.size > 0) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = toRemove[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _viewTag = _step1.value;
                            progressAnimations.delete(_viewTag);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    toRemove.clear();
                }
            }
        };
        return progressTransitionManager;
    };
    createProgressTransitionRegister.__closure = {};
    createProgressTransitionRegister.__initData = _worklet_15520481641365_init_data;
    createProgressTransitionRegister.__workletHash = 15520481641365;
    createProgressTransitionRegister.__stackDetails = _e;
    return createProgressTransitionRegister;
}();
var _worklet_7089923520308_init_data = {
    code: "function anonymous(){const{createProgressTransitionRegister}=this.__closure;global.ProgressTransitionRegister=createProgressTransitionRegister();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts",
    sourceMap: '{"version":3,"names":["anonymous","createProgressTransitionRegister","__closure","global","ProgressTransitionRegister"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/sharedTransitions/ProgressTransitionManager.ts"],"mappings":"AAgLmB,SAAAA,SAAMA,CAAA,QAAAC,gCAAA,OAAAC,SAAA,CAEvBC,MAAM,CAACC,0BAA0B,CAAGH,gCAAgC,CAAC,CAAC,CACxE"}',
    version: "3.5.4"
};
(0, _threads.runOnUIImmediately)(function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var anonymous = function anonymous() {
        global.ProgressTransitionRegister = createProgressTransitionRegister();
    };
    anonymous.__closure = {
        createProgressTransitionRegister: createProgressTransitionRegister
    };
    anonymous.__initData = _worklet_7089923520308_init_data;
    anonymous.__workletHash = 7089923520308;
    anonymous.__stackDetails = _e;
    return anonymous;
}())();
